<adaa-notes-popup #notesPopup (isSaved)="floatActionService.notesSaved.next(); notesPopup.modalRef.close()" />

<adaa-wf-history #workflowHistory />

<adaa-tp-directions-popup #directionsPopup />

@if (floatActionService.actions().length > 0) {
    <div class="float-container" [dir]="languageService.direction()" [class.expanded]="showActions()">
        @if (showActions()) {
            <div class="float-actions" role="navigation">
                <ul role="menu">
                    @for (action of floatActionService.actions(); track $index) {
                        <li>
                            <button
                                class="btn bg-card text-secondary d-flex align-items-center shadow fw-bold"
                                (click)="actionClicked({ action: action.key, data: action.data })"
                            >
                                @if (action.icon.type === "fa") {
                                    <fa-icon [icon]="getFaIcon(action.icon)" />
                                } @else if (action.icon.type === "adaa") {
                                    <i [class]="action.icon.value"></i>
                                }
                                <span class="px-2">{{ action.text | translate }}</span>
                            </button>
                        </li>
                    }
                </ul>
            </div>
        }

        <button class="toggle-btn btn shadow" (click)="showActions.set(!showActions())">
            <fa-icon [icon]="showActions() ? close : languageService.direction() === 'rtl' ? arrowRight : arrowLeft" />
        </button>
    </div>
}
